export const OPTIONS_TABS = [
  { label: 'AutoSyn', value: 'AutoSyn' },
  { label: 'SynJet', value: 'SynJet' },
  { label: 'SynJet Pro', value: 'SynJetPro' },
  { label: 'Lab', value: 'Lab' },
];
